export default {
    ranking: [],
    minigameScore: 0
};